export default __webpack_public_path__ + "resources/icons/n330-34c1.webp";